<ng-container *ngFor="let value of element.values">
    <div class="address-wrapper">
        <strong class="label">{{ getCustomLabel(value) | htmlDecode }}</strong>
        <span *ngIf="value.line1">{{ value.line1 }}</span>
        <span *ngIf="value.line2">{{ value.line2 }}</span>
        <div class="city-state-zip-wrapper">
            <span *ngIf="value.city">{{ value.city }}</span>
            <span *ngIf="getSelectedState(value)">{{ getSelectedState(value) }}</span>
            <span *ngIf="value.zip">{{ value.zip }}</span>
        </div>
        <span *ngIf="getSelectedCountry(value)">{{ getSelectedCountry(value) }}</span>
    </div>
</ng-container>